var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./marketplaceModuleSetup.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-09b4e3ea\",\"hasScoped\":false}!./marketplaceModuleSetup.html"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/marketplaceModuleSetup/marketplaceModuleSetup.vue
// module id = 2716
// module chunks = 1